import { useParamsSearch } from '@anytag/shared-hooks';
import { YoutubeTagRankingSearchListSchemaType } from '../schemaTypes';

export const useYoutubeTagRankingSearchFilter = () => useParamsSearch<YoutubeTagRankingSearchListSchemaType>();
